export function formatTimestamp(ts: number | undefined): string {
  if (!ts) return "-";
  const date = new Date(ts * 1000);
  return date.toLocaleString();
}

export function formatDuration(seconds: number | null | undefined): string {
  if (!seconds) return "-";
  if (seconds < 60) return `${seconds.toFixed(1)}s`;
  const minutes = Math.floor(seconds / 60);
  const secs = (seconds % 60).toFixed(0);
  return `${minutes}m ${secs}s`;
}

export function getScoreClass(score: number): string {
  if (score >= 0.8) return "text-green-600 font-semibold";
  if (score >= 0.5) return "text-yellow-600 font-semibold";
  return "text-red-600 font-semibold";
}

export function getStatusColor(status: string): string {
  switch (status) {
    case "pending":
      return "bg-yellow-100 text-yellow-800";
    case "running":
      return "bg-blue-100 text-blue-800";
    case "completed":
      return "bg-green-100 text-green-800";
    case "failed":
    case "error":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function truncateText(text: any, maxLength = 50): string {
  if (!text) return "";
  const str = typeof text === "object" ? JSON.stringify(text) : String(text);
  if (str.length <= maxLength) return str;
  return str.substring(0, maxLength) + "...";
}
